"use strict";

/* A service / model */

_BannerFlowApp.factory("Global", function () {
    return {
        IsLoading: false,
        Loading: function (loading) {
            this.IsLoading = loading;
        }
    };
});
